import dataCharacter from '../assets/dataCharacter.json';
import { calculStat } from './characterGeneration';

// ── Génération de nom ────────────────────────────────────────────
// Assemblage de syllabes (consonne+voyelle) + une terminaison, pour
// produire des noms fantasy prononçables (FR/EN).
const ONSETS = [
  'b', 'br', 'd', 'dr', 'f', 'g', 'gr', 'h', 'k', 'kr', 'l', 'm',
  'n', 'p', 'r', 's', 'st', 't', 'th', 'v', 'z', 'sh', 'gh', 'kh',
];
const VOWELS = ['a', 'e', 'i', 'o', 'u', 'ae', 'ei', 'ia', 'ou', 'y'];
const ENDINGS = [
  'n', 'r', 's', 'l', 'th', 'x', 'k', 'rn', 'ne', 'or', 'dor', 'wen',
  'ric', 'gar', 'mir', 'las', 'thas', 'wyn', 'dric', 'nor', 'a', 'iel',
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const generateNpcName = () => {
  const syllables = 2 + Math.floor(Math.random() * 2); // 2 ou 3
  let name = '';
  for (let i = 0; i < syllables; i++) {
    name += pick(ONSETS) + pick(VOWELS);
  }
  name += pick(ENDINGS);
  return capitalize(name);
};

// ── Génération de stats aléatoires ───────────────────────────────
const roll3d6 = () => (
  1 + Math.floor(Math.random() * 6)
  + 1 + Math.floor(Math.random() * 6)
  + 1 + Math.floor(Math.random() * 6)
); // 3 à 18, comme à la création d'un personnage

// Retourne { name, characteristics, skills, hp } prêt à sauvegarder.
export const generateNpc = () => {
  const characteristics = dataCharacter.characteristics.map((c) => ({
    label: c.label,
    value: roll3d6(),
  }));

  const findValue = (label) => {
    const found = characteristics.find((c) => c.label === label);
    return found ? found.value : 0;
  };

  const skills = dataCharacter.skills.map((s) => ({
    label: s.label,
    value: Math.min(90, calculStat(findValue(s.stat1), findValue(s.stat2), true)),
    isCustom: false,
    stat1: s.stat1,
    stat2: s.stat2,
  }));

  const hp = Math.min(findValue('endurance'), 14); // plafond identique à la création

  return {
    name: generateNpcName(),
    characteristics,
    skills,
    hp,
  };
};
